import { SliceProps } from "@/Slice/index"
import { JCRichText } from "@/components"
import { Link, NextImage } from "@jog/react-components"
import { asImageSrc, asLink, asText, isFilled } from "@prismicio/helpers"
import classNames from "classnames"

const gridOptions = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
}
const orderReverse = {
    1: "order-4",
    2: "order-3",
    3: "order-2",
    4: "order-1",
}
const textAlign = {
    center: "text-center",
    left: "text-left",
    right: "text-right",
} as const

export const ImageText = ({
    slice: { primary, items },
    className,
    lcp,
}: SliceProps<"image___text"> & { lcp: boolean }) => (
    <div className={classNames("grid gap-2", gridOptions[primary.columns] || gridOptions["1"], className)}>
        {items.map((item, i) => (
            <div
                className={classNames({
                    [`${orderReverse[i + 1]} md:order-none`]: primary.mobile_top === "Right Column",
                })}
                key={i}>
                {item.display_image && !isFilled.link(item.link) && isFilled.image(item.image) ? (
                    <NextImage
                        className="w-full"
                        alt={asText(item.title1)}
                        src={asImageSrc(item.image)}
                        width={item.image?.dimensions?.width}
                        height={item.image?.dimensions?.height}
                        lcp={lcp}
                    />
                ) : null}

                {item.display_image && isFilled.link(item.link) && isFilled.image(item.image) ? (
                    <Link
                        href={asLink(item.link)}
                        target={item.link.link_type === "Web" ? item.link.target : "_self"}
                        rel="noopener noreferrer"
                        external={true}
                        aria-label={asText(item.title1)}>
                        <NextImage
                            className="w-full"
                            alt=""
                            src={asImageSrc(item.image)}
                            width={item.image?.dimensions?.width}
                            height={item.image?.dimensions?.height}
                            lcp={lcp}
                        />
                    </Link>
                ) : null}
                <div className={classNames({ "flex h-full items-center justify-center": !item.display_image })}>
                    <div
                        className={classNames(
                            "py-2.5 px-2 text-gray-base",
                            item.display_image ? "md:px-0 md:py-0" : "md:px-24",
                            textAlign[primary.text_align] || "text-center"
                        )}>
                        {isFilled.richText(item.title1) && <JCRichText field={item.title1} />}
                        {isFilled.richText(item.rich_text) && <JCRichText field={item.rich_text} />}
                    </div>
                </div>
            </div>
        ))}
    </div>
)
